import { i18n } from 'i18n'
import { makeAutoObservable } from 'mobx'
import { api } from 'store/api'
import { skipAsync } from 'util/async'
import { validatePhone } from 'util/form'

export class PhoneFormStore {
  private _touch = false
  private _value = ''
  private _element: HTMLInputElement | undefined

  constructor() {
    makeAutoObservable(this)
  }

  check(): boolean {
    this.touch = true
    if (!this.error) return true
    this.element?.focus()
    return false
  }

  get touch(): boolean {
    return this._touch
  }

  set touch(value: boolean) {
    this._touch = value
  }

  get value(): string {
    return this._value
  }

  set value(value: string) {
    this._value = value
  }

  get element(): HTMLInputElement | undefined {
    return this._element
  }

  set element(value: HTMLInputElement | undefined) {
    this._element = value
  }

  reset() {
    this._touch = false
    this._value = ''
  }

  get error(): string | undefined {
    const phone = this._value.trim()
    if (!phone) return i18n('PleaseEnterPhone')
    if (!validatePhone(phone)) return i18n('PleaseEnterCorrectPhone')
    return undefined
  }

  readonly save = skipAsync(async () => {
    if (!this.check()) return
    const phone = this._value.trim()
    if (phone) {
      void api.updateUser({ phone })
    }
  })
}
